"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
var _ref = {},
  toString = _ref.toString;
function isObject(obj) {
  return toString.call(obj) === '[object Object]';
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfcmVmIiwidG9TdHJpbmciLCJpc09iamVjdCIsIm9iaiIsImNhbGwiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9pc09iamVjdC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCB7IHRvU3RyaW5nIH0gPSB7fTtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gaXNPYmplY3Qob2JqKSB7XG4gIHJldHVybiB0b1N0cmluZy5jYWxsKG9iaikgPT09ICdbb2JqZWN0IE9iamVjdF0nO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxJQUFBQSxJQUFBLEdBQXFCLENBQUMsQ0FBQztFQUFmQyxRQUFRLEdBQUFELElBQUEsQ0FBUkMsUUFBUTtBQUVELFNBQVNDLFFBQVFBLENBQUNDLEdBQUcsRUFBRTtFQUNwQyxPQUFPRixRQUFRLENBQUNHLElBQUksQ0FBQ0QsR0FBRyxDQUFDLEtBQUssaUJBQWlCO0FBQ2pEIn0=